import { Filter, FilterService } from './Filter';
import { getTotalInteractions } from '../assets/libs/broox/brooxCloudApi';
import { ChartInput } from './ChartInput';
import { AccountParams } from './AccountParams';

interface Interaction {
  count: number,
  time: number,
  most: { id: string, name: string, count: number },
  distribution: ChartInput
}

const getInteraction = async (filter: Filter, params: AccountParams): Promise<Interaction> => {
  // filter.cutoff (CX-638 §05) no llega aquí: getTotalInteractions delega en
  // el bundle vendorizado brooxCloudApi.js, cuyo parseFilter interno fuerza
  // endOf('day') sin ninguna forma de override. Arreglarlo exige que el
  // backend de la API cloud acepte un corte horario — fuera del alcance de
  // este repo.
  const data: any = await getTotalInteractions(filter, ['sensor', 'onevent'], params.host, params.token || params.id, params.apiKey);
  const result: Interaction = {
    count: data.interactions.count || 0,
    time: data.interactionTime.average || 0,
    most: data.mostInteracted || { count: 0 },
    distribution: { datasets: [{ data: [], backgroundColor: [] }], labels: [] }
  };
  for(let d of data.interactionsDistribution) {
    result.distribution.labels.push(d.label);
    result.distribution.datasets[0].data.push(d.value);
  }
  return result;
}

const getPreviousInteraction = async (filter: Filter, params: AccountParams): Promise<Interaction> => {
  filter = FilterService.parse(filter);
  filter = FilterService.previous(filter);
  return await getInteraction(filter, params);
}

export { Interaction, getInteraction, getPreviousInteraction };